import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'helpers/translateHelper';
import { roundNumber } from 'helpers/numberHelper';
import IconEchartTooltip from 'svgIcons/MotionPortalIcons/IconEchartTooltip';

const SpeedView = (props) => {
    const {
        points,
        frequencyUnitSymbol,
        magnitudeUnitSymbol,
        precision,
        speed
    } = props;
    const [frequency, timestamp, magnitude, originalMagnitude] = points.data;
    const displayMagnitude = originalMagnitude !== undefined ? originalMagnitude : magnitude;
    const frequencyRounded = roundNumber(frequency * (speed / 60), precision).toFixed(precision);

    return (
        <div className='speed-view-tooltip'>
            <div className='timestamp'>
                {timestamp}
            </div>
            <div className='divider' />
            <div className='series-name'>
                <IconEchartTooltip color={points.color} />
                <span>{points.seriesName}</span>
            </div>
            <div className='speed'>
                <span>{translate('ABB.Powertrain.Frontend.fftEchartSpeedXaxisText')}:</span>
                <span>{speed}</span>
            </div>
            <div className='magnitude'>
                <span>{translate('ABB.Powertrain.Frontend.fftEchartZAxisText')}:</span>
                <span>{displayMagnitude.toFixed(precision)} {magnitudeUnitSymbol}</span>
            </div>
            <div className='order-of-speed'>
                <span>{translate('ABB.Powertrain.Frontend.fftEchartOrderOfSpeedText')}:</span>
                <span>{frequency.toFixed(precision)}</span>
            </div>
            <div className='frequency'>
                <span>{translate('ABB.Powertrain.Frontend.fftEchartXAxisText')}:</span>
                <span>{frequencyRounded} {frequencyUnitSymbol}</span>
            </div>
        </div>
    );
};

SpeedView.propTypes = {
    points: PropTypes.shape({
        data: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])).isRequired,
        color: PropTypes.string,
        seriesName: PropTypes.string
    }).isRequired,
    frequencyUnitSymbol: PropTypes.string,
    magnitudeUnitSymbol: PropTypes.string,
    precision: PropTypes.number
};

SpeedView.defaultProps = {
    frequencyUnitSymbol: 'Hz',
    magnitudeUnitSymbol: '',
    precision: 2
};

export default SpeedView;
